import errorReducer from './error-reducer';

export default errorReducer;
